import FreeGamesByFawesome from "../components/FreeGamesByFawesome";

function FreeGamesByFawesomePage() {
  return <FreeGamesByFawesome />;
}
export default FreeGamesByFawesomePage;
